"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ignoreElements;
// Use to halt event propagation, like clicking on a link inside a clickable row

function findMatch(subjectValue, searchValues) {
  return searchValues.some(function (ignored) {
    return subjectValue.toLowerCase().includes(ignored);
  });
}
function ignoreElements() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$ignoredTags = _ref.ignoredTags,
    ignoredTags = _ref$ignoredTags === void 0 ? [] : _ref$ignoredTags,
    _ref$ignoredClasses = _ref.ignoredClasses,
    ignoredClasses = _ref$ignoredClasses === void 0 ? [] : _ref$ignoredClasses,
    _ref$ignoredTexts = _ref.ignoredTexts,
    ignoredTexts = _ref$ignoredTexts === void 0 ? [] : _ref$ignoredTexts;
  var event = arguments.length > 1 ? arguments[1] : undefined;
  var _event$target = event.target,
    className = _event$target.className,
    tagName = _event$target.tagName,
    textContent = _event$target.textContent;
  var classNameMatches = className && typeof className === 'string' && findMatch(className, ignoredClasses);
  var textContentMatches = findMatch(textContent, ignoredTexts);
  var tagNameMatches = findMatch(tagName, ignoredTags);
  return classNameMatches || tagNameMatches || textContentMatches;
}